import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SegmentCustomEvent } from '@ionic/angular';
import { endOfToday, isAfter } from 'date-fns';
import { filter, map, shareReplay, switchMap } from 'rxjs';
import { AppCommonModule } from '../common.module';
import { DashboardViewComponent } from '../components/views/dashboard/view-dashboard.component';
import { ContractorsService } from '../services/contractors.service';
import { PartnerInviteService } from '../services/partner-invite.service';
import { UsersService } from '../services/users.service';
import { isTimestamp } from '../utility/time';

@Component({
  selector: 'app-invites-page',
  templateUrl: './invites.page.html',
  styleUrls: ['./invites.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    CommonModule,
    DashboardViewComponent,
  ],
})
export class InvitesPage {

  private invites$ = this.usersService.getCurrentUser().pipe(
    filter((user) => user != null),
    switchMap((user) => this.service.getList({ inviter: user.guid })),
    map((invites) => invites.map((invite) => {
      const item = Object.assign({}, invite);
      if (isTimestamp(item.created)) {
        item.created = item.created.toDate();
      }
      return item;
    })),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  segmentValue = 'accepted';

  acceptedInvites$ = this.invites$.pipe(
    map((invites) => invites.filter((i) => i.contractor != null)),
    map((invites) => invites.map((i) => {
      const item = Object.assign({}, i, { contractor$: this.contractorsService.get(i.guid) });
      return item;
    })),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  waitingInvites$ = this.invites$.pipe(
    map((invites) => invites.filter((i) => i.contractor == null)),
    map((invites) => invites.filter((i) => isAfter(i.expires.toDate(), endOfToday()))),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(
    private contractorsService: ContractorsService,
    private service: PartnerInviteService,
    private usersService: UsersService,
  ) { }

  segmentChanged(event: SegmentCustomEvent) {
    this.segmentValue = event.detail.value.valueOf() as string;
  }
}
